import {
  NodeTypes,
  type ApiConnection,
  type Connections,
  type RefName,
} from "./core";

export const apiConnectionsToConnection = (
  apiConnections: ApiConnection,
): Connections => {
  return apiConnections
    .filter(({ ref_name }) => ref_name)
    .sort((a, b) => {
      // ref_name true should always go first
      if (a.ref_name === "true" && b.ref_name !== "true") return -1;
      if (a.ref_name !== "true" && b.ref_name === "true") return 1;
      return 0;
    })
    .reduce((acc, conn) => {
      acc[conn.ref_name] = {
        display_name: conn.display_name,
        target_node: conn.target_node_id,
      };
      return acc;
    }, {} as Connections);
};

export const getNodeDisplayName = (ref_name: RefName) => {
  switch (ref_name) {
    case NodeTypes.INITIALIZER:
      return "Inicializador";
    case NodeTypes.IF:
      return "Operador IF";
    case NodeTypes.SWITCH:
      return "Switch";
    case NodeTypes.FORM:
      return "Formulario";
    case NodeTypes.CALCULATED:
      return "Calculado";
    case NodeTypes.ASSIGN_GROUP:
      return "Asignar grupo";
    case NodeTypes.DATA_CENTER:
      return "Centro de Datos";
    case NodeTypes.EXPEDIENTE:
      return "Expediente Digital";
    case NodeTypes.CORRECTION:
      return "Revisión";
    case NodeTypes.DOC_GENERATOR:
      return "Generador de Documentos";
    case NodeTypes.PAYMENT:
      return "Pasarela de Pago";
    case NodeTypes.SIGN_DOCUMENT:
      return "Firma Digital";
    case NodeTypes.RESOLUTION:
      return "Resolución";
    case NodeTypes.MULTITHREAD:
      return "Multihilos";
    case NodeTypes.WAIT:
      return "Wait";
    case NodeTypes.NOTIFICATION:
      return "Notificación";
    case NodeTypes.INTEROPERABILITY:
      return "Interoperabilidad";
    case NodeTypes.N8N:
      return "Objeto N8N";
    case NodeTypes.ASSOCIATE_USER:
      return "Asociar usuario con usuario";
    case NodeTypes.CONFIRM_ASSOCIATE_USER:
      return "Confirmar asociación de usuarios";
    case NodeTypes.IMPERSONATION:
      return "Representación";
    case NodeTypes.HOLDER:
      return "Titular";
    case NodeTypes.PROCESSOR:
      return "Tramitador";
    case NodeTypes.END:
      return "Objeto de finalización";
    case NodeTypes.VARIABLE_REPLACEMENT:
      return "Suplencia de variables";
    case NodeTypes.SUBFLOW:
      return "Subflujo";
    case NodeTypes.HOLDER_COMPANY:
      return "Empresa";
    case NodeTypes.MERGE:
      return "Merge";
    default:
      return "Desconocido";
  }
};

export const getExternalNodeName = (type: RefName) => {
  switch (type) {
    case NodeTypes.INITIALIZER:
      return "Inicializador";
    case NodeTypes.FORM:
      return "Formulario";
    case NodeTypes.CORRECTION:
      return "Revisión";
    case NodeTypes.IF:
      return "Condicional";
    case NodeTypes.SWITCH:
      return "Switch";
    case NodeTypes.MULTITHREAD:
      return "Multihilo";
    case NodeTypes.WAIT:
      return "Espera";
    case NodeTypes.ASSIGN_GROUP:
      return "Asignar grupo";
    case NodeTypes.DATA_CENTER:
      return "Centro de datos";
    case NodeTypes.EXPEDIENTE:
      return "Expediente";
    case NodeTypes.NOTIFICATION:
      return "Notificación (Email/SMS)";
    case NodeTypes.CALCULATED:
      return "Campo calculado";
    case NodeTypes.PAYMENT:
      return "Pasarela de pago";
    case NodeTypes.N8N:
      return "Objeto N8N";
    case NodeTypes.INTEROPERABILITY:
      return "Interoperabilidad";
    case NodeTypes.DOC_GENERATOR:
      return "Generador de documentos";
    case NodeTypes.SIGN_DOCUMENT:
      return "Firma digital";
    case NodeTypes.RESOLUTION:
      return "Resolución de trámites";
    case NodeTypes.ASSOCIATE_USER:
      return "Asociar usuario con usuario";
    case NodeTypes.CONFIRM_ASSOCIATE_USER:
      return "Confirmar asociación de usuarios";
    case NodeTypes.VARIABLE_REPLACEMENT:
      return "Suplencia de variables";
    case NodeTypes.END:
      return "Objeto de finalización";
  }
};
